import Book from './book'

export default class PagedBook {
  public books: Book[] = []

  public pageIndex = 1
}
